import { isMFieldValueExists } from '../../utils/mandatoryFieldsMeta';
import { MFieldName } from '../../types/MandatoryFields';
import { MFieldState } from './types';

export const createMFieldState = (
  mFieldName: MFieldName,
  initial?: Partial<MFieldState>
): MFieldState => ({
  value: undefined,
  isValid: isMFieldValueExists(initial?.value),
  touched: false,
  ...initial,
  name: mFieldName,
});
